module.exports = __webpack_public_path__ + "media/images/photo/plans/shooting-spots/shooting-spot-kansai-6-cb0c94539a2792c95753c9a12d0005fb.png";